import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateModal } from '@/store/modules/modal';
import styled from 'styled-components';
import BTN_BG from '@/assets/payment/paymentButton.png';
import BTN_BG_ACTIVE from '@/assets/payment/paymentButtonActive.png';

function GlobalPaymentCreateButton() {
  const dispatch = useAppDispatch();
  const onCloseModal = (type?: string) => {
    dispatch(updateModal({ isActive: false, data: null, type: type || null }));
  };
  return (
    <Button
      onMouseOut={(e) => {
        (
          e.currentTarget as HTMLButtonElement
        ).style.backgroundImage = `url(${BTN_BG})`;
      }}
      onMouseDown={(e) => {
        (
          e.currentTarget as HTMLButtonElement
        ).style.backgroundImage = `url(${BTN_BG_ACTIVE})`;
      }}
      onMouseUp={(e) => {
        (
          e.currentTarget as HTMLButtonElement
        ).style.backgroundImage = `url(${BTN_BG})`;
      }}
      onClick={() => {
        dispatch(
          updateModal({
            isActive: true,
            type: 'PAYMENT_CREATE',
            data: {
              onClick: () => {},
              onClose: onCloseModal,
            },
          }),
        );
      }}
    />
  );
}
export default GlobalPaymentCreateButton;

const Button = styled.button`
  background-image: url(${BTN_BG});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 178px;
  height: 52px;
  border: none;
  cursor: pointer;
  background-color: transparent;
  filter: drop-shadow(0px 6px 12px rgba(51, 177, 91, 0.14));
`;
